import { useState } from "react";

export default function RupiahInput({
  value,
  onChange,
  placeholder = "0",
  isErr,
  ...props
}) {
  const [internalValue, setInternalValue] = useState(value ?? "");

  const formatRupiah = (angka) => {
    const numberString = angka.toString().replace(/[^0-9]/g, "");
    return numberString.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const handleChange = (e) => {
    const rawValue = e.target.value.replace(/[^0-9]/g, ""); // hanya angka
    const formatted = formatRupiah(rawValue);
    setInternalValue(formatted);

    if (onChange) {
      onChange(rawValue === "" ? "" : Number(rawValue)); // kirim angka murni
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      <div
        style={
          !isErr
            ? {
                display: "flex",
                alignItems: "center",
                border: "1px solid #d1d5db",
                borderRadius: 8,
                overflow: "hidden",
                background: "#fff",
              }
            : {
                display: "flex",
                alignItems: "center",
                border: "1px solid red",
                borderRadius: 8,
                overflow: "hidden",
                background: "#fff",
              }
        }
      >
        <span
          style={{
            padding: "10px 12px",
            background: "#f3f4f6",
            color: "#374151",
            fontSize: 16,
            fontWeight: 600,
            borderRight: "1px solid #d1d5db",
          }}
        >
          Rp
        </span>
        <input
          type="text"
          inputMode="numeric"
          value={internalValue}
          onChange={handleChange}
          placeholder={placeholder}
          style={{
            flex: 1,
            border: "none",
            outline: "none",
            padding: "10px 12px",
            fontSize: 16,
            color: "#111827",
          }}
          {...props}
        />
      </div>
    </div>
  );
}
